var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.value
    ? _c(
        "w-modal",
        { attrs: { value: _vm.value != null } },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _vm.isNum
                            ? _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.label,
                                  decimals: _vm.decimals,
                                },
                                model: {
                                  value: _vm.result.numValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.result, "numValue", $$v)
                                  },
                                  expression: "result.numValue",
                                },
                              })
                            : _vm._e(),
                          _vm.isString
                            ? _c("app-extra-fields-edit-text", {
                                attrs: {
                                  config: _vm.value.config,
                                  fancy: "",
                                  label: _vm.label,
                                },
                                model: {
                                  value: _vm.result.textValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.result, "textValue", $$v)
                                  },
                                  expression: "result.textValue",
                                },
                              })
                            : _vm._e(),
                          _vm.isBoolean
                            ? _c("w-checkbox", {
                                attrs: { fancy: "", label: _vm.label },
                                model: {
                                  value: _vm.result.boolValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.result, "boolValue", $$v)
                                  },
                                  expression: "result.boolValue",
                                },
                              })
                            : _vm._e(),
                          _vm.isDate
                            ? _c("w-date-picker", {
                                attrs: {
                                  "popover-visibility": "focus",
                                  nullable: "",
                                  locale: _vm.locale,
                                  fancy: "",
                                  label: _vm.label,
                                },
                                model: {
                                  value: _vm.result.timeValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.result, "timeValue", $$v)
                                  },
                                  expression: "result.timeValue",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "check", disabled: _vm.sending },
                      on: {
                        click: function ($event) {
                          return _vm.confirm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }